import { FaPhoneAlt } from 'react-icons/fa';
import { CONTACT } from '../constants/contact';
import './FixedCallBar.css';

export default function FixedCallBar() {
  return (
    <div className="dh-callbar">
      <a href={CONTACT.phoneTel} className="dh-callbar__btn" aria-label={`Call ${CONTACT.phone}`}>
        <FaPhoneAlt aria-hidden />
        <span className="dh-callbar__text">
          <strong>Call Now {CONTACT.phone}</strong>
        </span>
      </a>
    </div>
  );
}
